import React from "react";
import './styles.css';

let resolve;

const defaultProps = {
  title: 'Confirmation',
  message: 'Are you sure?'
};


class NuConfirm extends React.Component { 
  constructor() {
    console.log("constructor");
    super();
    

    this.state = {
      isOpen: false,
      showConfirmProps: {},
    };

    this.handleCancel = this.handleCancel.bind(this);
    this.handleConfirm = this.handleConfirm.bind(this); 
    this.show = this.show.bind(this);
    this.refBtn = React.createRef();
  }
    // --------------------------------------
    onClickItem = (e,item) => {
      e.target.name = this.props.name;
      e.target.value = item.value;
      this.props.onChange(e);
    }; 
    //------------------------------------
    //---------------------------------------------------------
    handleCancel() {
      this.setState({ isOpen: false });
      
      //resolve(false);
      //this.props.reject(); /* callback */
      /*if (this.state.showConfirmProps.reject) {
        this.state.showConfirmProps.reject();
      }    */
    }
    //-----------------------------------
    handleConfirm() {
      this.setState({ isOpen: false });
      //resolve(true);
      //this.props.accept(); /* callback */
      
      if (this.state.showConfirmProps.accept) {
        this.state.showConfirmProps.accept({ data: 'val' });
      }    
    }
    //===============================================================
    show(props = {}) {
      console.log("show props");
      console.log("this.props: "+ props);

      console.log ( JSON.stringify( this.props))

      const showConfirmProps = { ...this.props.createConfirmProps, ...props };
      this.setState({ isOpen: true, showConfirmProps });

      //------------ colocamos el enfoque en el boton
      //this.refBtn.current.focus();

      // colocamos el enfoque despues de 1 segundo
      //-- tambien e agregado la clase focus-visible, para que el boton este resaltado
      setTimeout(() => {
        //setDataLoaded(true)
        console.log("focus t")
        this.refBtn.current.focus();
      }, 300)
      //const showConfirmProps = { ...props };      
      //this.setState({ isOpen: true, showConfirmProps });
      //console.log ( JSON.stringify( this.state))

      return new Promise((res) => {
        resolve = res;
      });
    }
    //=======================================
    render() {
       const { name, value, options } = this.props;

      const { isOpen, showConfirmProps } = this.state;
      const { message, title, icon, acceptLabel, rejectLabel,classHeader, classButton, ...rest } = showConfirmProps;

      const headerCls = `modal-header1 ${classHeader}`;
      const footerBtnCls = ` ${classButton}`; 
       //const miClassName = `nu-sidenav_item ${ value===item.value? "menu-item--active":'' }`;
       
       return (
        <>
      

        <div className="modal-backdrop fade1 in" style={{display: this.state.isOpen ? 'block' : 'none'}}></div>
        {/* 
          JSON.stringify(this.state)*/
        }
        <div className='modal fade1 in' tabIndex="-1" role="dialog" style={{display: this.state.isOpen ? 'block' : 'none'}} >
          <div className="modal-dialog modal-sm modal-dialog-centered">
            <div className="modal-content1">
              
              <div className={headerCls}>         {/*"modal-header1 bg-default text-default">*/}
                <button type="button" 
                        className="close" 
                        data-dismiss="modal" 
                        aria-label="Close" 
                        onClick={this.handleCancel}>
                  <span aria-hidden="true">×</span>
                </button>
                <h4 className="modal-title">{title || defaultProps.title}</h4>
              </div>
              <div className="modal-body1">
                <i className= {icon || defaultProps.icon} ></i>
                {message || defaultProps.message}
              </div>
              <div className="modal-footer1">
                
                
                <button className={ `${footerBtnCls} focus-visible"` } 
                        ref={ this.refBtn } 
                        onClick={this.handleConfirm}
                        autoFocus
                        >{ acceptLabel || defaultProps.acceptLabel }
                </button>
                &nbsp;
                <button className="btn btn-default" 
                        onClick={this.handleCancel}>{ rejectLabel || defaultProps.rejectLabel }
                </button>
              </div>
            </div>
          </div>
        </div>
          
  
        
        </>
        );
     }
};
export default NuConfirm;